

define(['squid/index', 'text!./template.html', './phoneInput/directive', 'components/xo-models/src/checkout/index', 'components/xo-models/src/user/index', 'components/xo-ui-components/src/message/directive', 'components/xo-models/src/auth/index', 'components/xo-title/dist/directive', 'components/xo-page-components/src/value-props/directive'], function (squid, template) {

    squid.module('xo-phone.directive', ['squid', 'xo-phone.phoneInput', 'xomodel.checkout', 'xomodel.user', 'xomodel.auth', 'xo-message.directive', 'xo-title.directive', 'xo-value-props.directive']).directive('xoAddPhone', function () {
        return {
            template: template,
            scope: {},
            controller: function controller($scope, $rootScope, $location, $populate, $UserInfoModel, $state, $locale, $featureCountries, $CheckoutSessionModel, $util, $logger, $AuthModel, $feature) {

                $scope.showPhoneDisclosure = $featureCountries('showPhoneDisclosure').indexOf($locale.country) > -1;
                $scope.phoneConsent = $feature('phoneConsent');
                $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
                $scope.errorMessage = {
                    msgKeys: ['addPhone.addPhoneNumberConsent'],
                    type: 'info'
                };

                $scope.userInfo = $UserInfoModel.instance($rootScope.token);

                var CONTENT_KEY = {
                    INVALID_PHONE_NUMBER: 'validPhone'
                };

                var CONTENT_MAPPING = {
                    numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
                    typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
                };

                var populateErrorMessage = function populateErrorMessage(name) {
                    var contentKey = CONTENT_MAPPING[name];
                    var msg = contentKey ? $locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;

                    $scope.errorMessage = {
                        msgs: [msg],
                        type: 'error'
                    };
                };

                var validationErrorHandler = {
                    numberError: populateErrorMessage,
                    typeError: populateErrorMessage
                };

                $populate($scope, {
                    auth: $AuthModel.instance()
                }).then(function () {

                    $scope.logout = function () {
                        $logger.info('not_you_logout');
                        $scope.auth.action('logout').then(function () {
                            $state.go('checkout.login');
                        });
                    };

                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;

                    $scope.onSubmit = function () {
                        if ($scope.phoneConsent) {
                            $scope.phone.consent = {
                                agreed: true,
                                contentId: $locale.country + ':' + $locale.lang + ':' + $scope.consentContentKey
                            };
                        }
                        $scope.userInfo.action('addPhone', {

                            data: $scope.phone,

                            success: function success(data) {
                                return $CheckoutSessionModel.instance($rootScope.token).action('create', {
                                    success: function success() {
                                        $state.go('checkout.review');
                                    }
                                });
                            },

                            contingencies: {
                                NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                                    $location.path('/checkout/addCard');
                                },

                                EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
                                    $location.path('/checkout/updateCard');
                                }
                            },

                            validation: function validation(data) {
                                angular.forEach(data, function (value, key) {
                                    validationErrorHandler[key](key);
                                });
                            }
                        });
                    };
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-form-components/src/phone/directive.js
 ** module id = 455
 ** module chunks = 1
 **/